/** Artboard 3 · Nuevo reporte — a sheet over the list. Name and destination, both required (50 km rule). */
import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ApiError, call } from '../api/client.ts';
import { Button, Sheet } from '../theme/ui.tsx';

export default function NuevoViaje() {
  const nav = useNavigate(); const [sp] = useSearchParams();
  const then = sp.get('then');
  const [name, setName] = useState(''); const [destination, setDestination] = useState('');
  const [busy, setBusy] = useState(false); const [error, setError] = useState<string | null>(null);
  const close = () => nav(-1);
  const submit = async (e: FormEvent) => {
    e.preventDefault(); if (!name.trim() || !destination.trim()) { setError('Nombre y destino son obligatorios.'); return; }
    setBusy(true); setError(null);
    try {
      const { tripId } = await call('trips.create', { body: { name: name.trim(), destination: destination.trim() } });
      nav(then ? `${then}${then.includes('?') ? '&' : '?'}reporte=${tripId}` : `/reporte/${tripId}`, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.entityRequired) { nav('/', { replace: true }); return; }   // the first-use card asks for the company first
      setError(err instanceof ApiError ? err.message : 'No se pudo crear el reporte.'); setBusy(false);
    }
  };
  return (
    <Sheet onClose={close}>
      <form onSubmit={submit} style={{ display: 'contents' }}>
        <div className="h2">Nuevo reporte</div>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-2)' }}>Nombre</span>
          <input className="input" autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="Monterrey — cliente Alfa" maxLength={200} />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <span style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}><span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-2)' }}>Destino</span><span style={{ fontSize: 11.5, color: 'var(--ink-3)' }}>lo pide el área fiscal</span></span>
          <input className="input" value={destination} onChange={(e) => setDestination(e.target.value)} placeholder="Ciudad, o la oficina si no es viaje" maxLength={200} />
        </label>
        <div style={{ fontSize: 13, color: error ? 'var(--red)' : 'var(--ink-2)', lineHeight: 1.45 }}>{error ?? 'Nada más. Las fechas salen solas de los comprobantes que subas.'}</div>
        <Button type="submit" busy={busy}>Crear reporte</Button>
      </form>
    </Sheet>
  );
}
